<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-70 md-small-size-100">
      <div class="md-layout">
        <label class="md-layout-item md-size-30 md-form-label">
          Dirección de residencia
        </label>
        <div class="md-layout-item">
          <md-field v-model="residenceAddress">
            <label>{{ residenceAddress }}</label>
            <md-input disabled></md-input>
          </md-field>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-30 md-small-size-100">
      <md-button
        @click="modalAdress = true"
        class="md-layout-item md-primary md-round"
        ><md-icon>edit_location</md-icon> Editar Dirección</md-button
      >
    </div>
    <modal v-if="modalAdress" @close="noticeModalHide">
      <template slot="header">
        <h4 class="modal-title">
          Llena los campos necesarios para construir tu dirección
        </h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="noticeModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item md-size-35">
            <ApolloQuery
              :query="require('../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_START_ADRESS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainIncomeSalary"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': false }
                    ]"
                  >
                    <label for="select">Vía</label>
                    <md-select v-if="data" v-model="adress0" name="select">
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.value"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-20">
            <ValidationProvider
              name="capDomainIncomeSalary"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': false }
                ]"
              >
                <label>Nro</label>
                <md-input v-model="adress1" type="number"> </md-input>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-20">
            <ApolloQuery
              :query="require('../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_PARTITION_ADRESS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainIncomeSalary"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': false }
                    ]"
                  >
                    <label for="select">Partición</label>
                    <md-select v-if="data" v-model="adress2" name="select">
                      <md-option value="">--</md-option>
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.value"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-25">
            <ApolloQuery
              :query="require('../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_ORIENTATION_ADRESS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainIncomeSalary"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': false }
                    ]"
                  >
                    <label for="select">Orientación</label>
                    <md-select v-if="data" v-model="adress3" name="select">
                      <md-option value="">--</md-option>
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.value"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-20">
            <ValidationProvider
              name="capDomainIncomeSalary"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': false }
                ]"
              >
                <label>Nro</label>
                <md-input v-model="adress4" type="number"> </md-input>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-20">
            <ApolloQuery
              :query="require('../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_PARTITION_ADRESS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainIncomeSalary"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': false }
                    ]"
                  >
                    <label for="select">Partición</label>
                    <md-select v-if="data" v-model="adress5" name="select">
                      <md-option value="">--</md-option>
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.value"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-20">
            <ValidationProvider
              name="capDomainIncomeSalary"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': false }
                ]"
              >
                <label>- Nro</label>
                <md-input v-model="adress6" type="number"> </md-input>
              </md-field>
            </ValidationProvider>
          </div>
        </div>
        <p>
          Si tienes preguntas, no dudes en contactarnos en la opción de Crear
          Ticket
        </p>
      </template>

      <template slot="footer">
        <md-button class="md-primary md-round" @click="updateAdress()"
          >Guardar</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import Constants from "../../constants";
import Swal from "sweetalert2";
export default {
  name: "AdressPicker",
  components: {
    Modal
  },
  props: {},
  data() {
    return {
      residenceAddress: null,
      modalAdress: false,
      adress0: "",
      adress1: "",
      adress2: "",
      adress3: "",
      adress4: "",
      adress5: "",
      adress6: "",
      Constants: Constants
    };
  },
  methods: {
    updateAdress() {
      if (!this.adress0 || !this.adress1 || !this.adress4 || !this.adress6)
        Swal.fire({
          title: "¡Dirección inválida!",
          text: "Llena los campos necesarios para costruir la dirección",
          timer: 2000,
          showConfirmButton: false
        });
      else {
        this.residenceAddress =
          this.adress0 +
          " " +
          this.adress1 +
          this.adress2 +
          " " +
          this.adress3 +
          " #" +
          this.adress4 +
          this.adress5 +
          "-" +
          this.adress6;
        this.modalAdress = false;
        this.$emit("residenceAddress", this.residenceAddress);
      }
    },
    noticeModalHide: function() {
      this.modalAdress = false;
    }
  }
};
</script>

<style></style>
